/**
 * Visitor Tracker - 방문자 추적 (서버 전송 + 이탈 추적)
 */
(function() {
  var STORAGE_KEY = 'hub_visitor';
  var pageLoadTime = Date.now();

  // 기존 데이터 로드
  var data = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

  // 초기화
  if (!data.firstVisit) {
    data.firstVisit = new Date().toISOString();
  }
  data.lastVisit = new Date().toISOString();
  data.totalVisits = (data.totalVisits || 0) + 1;
  data.pageViews = data.pageViews || {};
  data.postViews = data.postViews || {};

  // 현재 페이지 조회수
  var currentPath = window.location.pathname;
  data.pageViews[currentPath] = (data.pageViews[currentPath] || 0) + 1;

  // 포스트 페이지인 경우 별도 추적
  if (currentPath.startsWith('/post/')) {
    var slug = currentPath.replace('/post/', '');
    data.postViews[slug] = (data.postViews[slug] || 0) + 1;
  }

  // 저장
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

  // CSRF 토큰
  var csrfToken = document.querySelector('meta[name="csrf-token"]');
  var token = csrfToken ? csrfToken.getAttribute('content') : '';

  // 서버로 방문 로그 전송
  if (token) {
    fetch('/api/visitor-log', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': token
      },
      body: JSON.stringify({
        path: currentPath,
        total_visits: data.totalVisits,
        page_views: data.pageViews[currentPath],
        referrer: document.referrer || null
      })
    }).catch(function() {});
  }

  // 이탈 추적 (페이지 떠날 때)
  var exitSent = false;
  function sendExitBeacon() {
    if (exitSent) return;
    exitSent = true;

    var duration = Math.round((Date.now() - pageLoadTime) / 1000);

    // sendBeacon 시도 (권장)
    if (navigator.sendBeacon) {
      var formData = new FormData();
      formData.append('path', currentPath);
      formData.append('duration', duration);
      var sent = navigator.sendBeacon('/api/visitor-exit', formData);
      if (sent) return;
    }

    // fallback: fetch with keepalive
    fetch('/api/visitor-exit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: currentPath, duration: duration }),
      keepalive: true
    }).catch(function() {});
  }

  // 페이지 이탈 이벤트
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'hidden') {
      sendExitBeacon();
    }
  });

  window.addEventListener('pagehide', sendExitBeacon);
  window.addEventListener('beforeunload', sendExitBeacon);

  // iOS Safari 호환: 링크 클릭 시 이탈 전송
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (link && link.href && !link.href.startsWith('javascript:')) {
      // 같은 페이지 앵커가 아닌 경우만
      if (link.pathname !== currentPath || link.host !== window.location.host) {
        sendExitBeacon();
      }
    }
  });

  // iOS Safari 호환: 터치로 뒤로가기 감지
  window.addEventListener('touchstart', function() {}, { passive: true });

  // 전역 접근용
  window.HubVisitor = {
    getData: function() { return data; },
    getTotalVisits: function() { return data.totalVisits; },
    getPageViews: function(path) { return data.pageViews[path || currentPath] || 0; },
    getPostViews: function(slug) { return data.postViews[slug] || 0; },
    getDuration: function() { return Math.round((Date.now() - pageLoadTime) / 1000); },
    clear: function() { localStorage.removeItem(STORAGE_KEY); }
  };
})();
